
import { classNames } from "utils";
import { FC, useState } from "react";
import type { Complaint } from "./schema";
import ComplaintDetailsContainer from "./containers/details";
import ChildComplaintsContainer from "./containers/child-complaints";
import { Tabs } from "components";

interface DetailsContainerProps {
  complaint?: Complaint;
}


const detailsTabs = [
  {
    name: "Complaint Details",
    href: "details",
  },
  {
    name: "Child Complaints",
    href: "children",
  },
];

const DetailsContainer: FC<DetailsContainerProps> = ({ complaint }) => {

  const [detailsTab, setDetailsTab] = useState<'details' | 'children'>('details')

  return (
    <section aria-labelledby="applicant-information-title">
      <div
        className={classNames(
          complaint?.servicePoint ? "sm:rounded-t-lg" : "sm:rounded-lg",
          "bg-white shadow"
        )}
      >
        <div className="px-4 pt-5 pb-2 sm:px-6">
          <h2
            id="applicant-information-title"
            className="text-lg font-medium leading-6 text-gray-900"
          >
            Complaint #{complaint?.code}
          </h2>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            {
              detailsTab === 'details' ? (
                <span>
                  Personal details and complaint details.
                </span>
              ) : detailsTab === 'children' ? (
                <span>
                  Information about the complaints grouped under this ticket.
                </span>
              ): "Complaint Details"
            }
          </p>
        </div>  
        <Tabs tabs={detailsTabs} onTabChanged={(tab: any) => setDetailsTab(tab)} />
        {detailsTab === 'details' && <ComplaintDetailsContainer complaint={complaint} />}
        {detailsTab === 'children' && <ChildComplaintsContainer complaint={complaint} />}
      </div>
    </section>
  );
};

export default DetailsContainer;
